import React from "react";
import BaseField, { BaseFieldProps } from "./BaseField";
import OptionsSelector, { OptionsSelectorProps } from "./OptionsSelector";

type OptionsFieldProps<V> = Omit<BaseFieldProps, "component" | "hasValue"> &
    OptionsSelectorProps<V>;

const OptionsField = <V,>({
    style,
    label,
    placeholder,
    disabled,
    value,
    left,
    right,
    error,
    ...props
}: OptionsFieldProps<V>) => {
    return (
        <BaseField
            style={[
                {
                    paddingHorizontal: 0,
                    flexDirection: "row",
                    borderWidth: 0,
                },
                style,
            ]}
            isSelfContained
            value={true}
            label={label !== undefined ? label : ""}
            placeholder={placeholder !== undefined ? placeholder : ""}
            disabled={disabled}
            left={left}
            right={right}
            error={error}
            component={<OptionsSelector disabled={disabled} value={value} {...props} />}
        />
    );
};

export default OptionsField;
